export default __webpack_public_path__ + "static/media/main-full-bg-01.268df70d.png";